module.exports = __webpack_public_path__ + "static/media/REP.b8370638.png";